import DisabledServices from "../DisabledServices"
import localStorageKey from "../localStorageKey"

const getDisabledServices = (): DisabledServices => {
    const disabledServicesObjStr: string | null = localStorage.getItem(localStorageKey)
    let disabledServicesObj: DisabledServices
    if (!disabledServicesObjStr) {
        disabledServicesObj = new DisabledServices()
    } else {
        disabledServicesObj = JSON.parse(disabledServicesObjStr)
    }
    return disabledServicesObj
}

export default getDisabledServices